/**
 * Data Studio (kho tri thức dùng chung mọi site, theo module) mở cho mọi tài khoản của site nền tảng.
 * Engine chặn ở API (`require_kb_admin`, cờ `/v1/aihub/me` → `kb_admin`); hàm này chỉ để ẩn UI sớm.
 */
import { createContext, useContext } from 'react';
import type { AiHubMe } from '@/types/ai-agent';

/** Site sở hữu kho tri thức — khớp `KB_PLATFORM_TENANT` của engine. */
export const KNOWLEDGE_PLATFORM_SITE = 'TOPPION HOLDING';

export function isKnowledgePlatformSite(tenantId?: string | null): boolean {
  const site = (tenantId ?? '').trim();
  return Boolean(site) && site.localeCompare(KNOWLEDGE_PLATFORM_SITE, undefined, { sensitivity: 'accent' }) === 0;
}

type AdminFlags = { isAdmin?: boolean | null; isAdminBsc?: boolean | null } | null | undefined;

/** Kho tri thức: mọi tài khoản site nền tảng xem / tra cứu; engine xác nhận qua `me.kb_admin` khi đã tải. */
export function canManageKnowledge(tenantId: string | null | undefined, _profile?: AdminFlags, me?: AiHubMe | null): boolean {
  if (!isKnowledgePlatformSite(tenantId)) return false;
  return me ? Boolean(me.kb_admin) : true;
}

/** Menu + trang AI Coaching: Admin site nền tảng (TOPPION HOLDING) hoặc email trong whitelist của engine
 *  (`me.ai_coaching_whitelisted`). Engine kiểm lại quyền ở API. */
export function canUseAiCoaching(tenantId: string | null | undefined, profile?: AdminFlags, me?: AiHubMe | null): boolean {
  return (isKnowledgePlatformSite(tenantId) && Boolean(profile?.isAdmin)) || Boolean(me?.ai_coaching_whitelisted);
}

/** Thêm / sửa / xoá kho, tài liệu, nguồn, module: chỉ Admin site nền tảng (`me.kb_write`). */
export function canEditKnowledge(me?: AiHubMe | null): boolean {
  return Boolean(me?.kb_write);
}

/** Data Studio đang ở chế độ chỉ xem (tài khoản không phải Admin site nền tảng) — các panel tắt nút ghi. */
export const KbReadOnlyContext = createContext(false);
export const useKbReadOnly = () => useContext(KbReadOnlyContext);
